import type {
  FrapiList,
  FrapiTeaserItem,
} from '../../../../types/frapi-types.js';

export const isListOfTeasers = (
  items: FrapiList['items'],
): items is FrapiTeaserItem[] =>
  !!items && items.every((item) => item.type === 'teaser');
